var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFdSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 11.416H9.33333M9.33333 11.416L12.4583 14.541M9.33333 11.416L12.4583 8.29102",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20801 15.5833V7.25M0.999673 11.4167C0.999673 16.3271 0.999673 18.7823 2.52571 20.3073C4.04967 21.8333 6.50592 21.8333 11.4163 21.8333C16.3268 21.8333 18.782 21.8333 20.308 20.3073C21.833 18.7833 21.833 16.3271 21.833 11.4167C21.833 6.50625 21.833 4.05104 20.308 2.525C18.7809 1 16.3268 1 11.4163 1C6.50592 1 4.05071 1 2.52571 2.525C1.51113 3.53958 1.17155 4.96563 1.05696 7.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdSelect);
export default __webpack_public_path__ + "static/media/fd_select.ffeef2455767d3ebc994da668dbc8900.svg";
export { ForwardRef as ReactComponent };